import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const AutorizacionesDetailModal = ({ isOpen, onClose, detailData, selectedDelegacionFilter }) => {
  if (!isOpen || !detailData) {
    return null;
  }

  const { clickedDate, clickedChannel, usersAndDelegations } = detailData;

  return (
    <Modal show={isOpen} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          Detalle de Autorizaciones para {clickedChannel} en {clickedDate}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>Usuarios y Delegaciones:</h5>
        {usersAndDelegations.length > 0 ? (
          <TableContainer component={Paper}>
            <Table size="small" aria-label="user and delegation details table">
              <TableHead>
                <TableRow>
                  <TableCell>Delegación</TableCell>
                  <TableCell>Usuario</TableCell>
                  <TableCell align="right">Órdenes</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {usersAndDelegations.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {item.delegacion ? item.delegacion : 'N/A'}
                    </TableCell>
                    <TableCell>{item.indicador}</TableCell>
                    <TableCell align="right">{item.valor}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <p>No hay detalles de usuarios para este segmento.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AutorizacionesDetailModal;
